<p-multiselect
  [ngModel]="value()"
  (ngModelChange)="value.set($event)"
  [options]="options()"
  [optionLabel]="optionLabel()"
  [optionValue]="optionValue()"
  [placeholder]="placeholder()"
  [disabled]="disabled()"
  [filter]="filter()"
  [showClear]="showClear()"
  [appendTo]="appendTo()"
  [styleClass]="styleClass()"
  [maxSelectedLabels]="maxSelectedLabels()"
  [selectedItemsLabel]="selectedItemsLabel()"
  [display]="display()"
  [emptyMessage]="emptyMessage()"
  [emptyFilterMessage]="emptyFilterMessage()"
  (onChange)="handleChange($event)"
  (onClear)="handleClear()"
  [size]="size()"
  [loading]="loading()"
  [selectionLimit]="selectionLimit()!">

  <ng-template *ngIf="itemTemplate()" pTemplate="item" let-item>
    <ng-container *ngTemplateOutlet="itemTemplate()!; context: { $implicit: item }"></ng-container>
  </ng-template>

</p-multiselect>
